import axios from 'axios'

export const getMyOnboardingSteps = () => {
  return axios.get('/office-activity/my-onboarding-steps')
}

export const getMyOnboardingAllSteps = () => {
  return axios.get('/office-activity/my-onboarding-all-steps')
}

export const loadAllOnboardingSteps = () => {
  return getMyOnboardingAllSteps()
}

export const submitOnboardingActivity = ({ officeActivityListId }) => {
  return axios.post(`/office-activity/submit/${officeActivityListId}`)
}

export const launchOnboardingActivityCourse = ({ officeActivityListId }) => {
  return axios.post(`/office-activity/launch-course/${officeActivityListId}`)
}
